export enum DrawingMode {
    All,
    NoOverlays,
    Leadsheet
}

export enum MusicSymbolDrawingStyle {
    Normal,
    Disabled,
    Selected,
    Clickable,
    PlaybackSymbols,
    FollowSymbols,
    QFeedbackNotFound,
    QFeedbackOk,
    QFeedbackPerfect,
    Debug1,
    Debug2,
    Debug3
}

export enum PhonicScoreModes {
    Following,
    Midi,
    Manual
}
